"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgWalkingMan(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.4 95.3c0-52.4 42.9-95.3 95.3-95.3S655 42.9 655 95.3s-42.9 95.3-95.3 95.3c-52.5-.1-95.3-43-95.3-95.3zm357.2 452.4v-95.3c-90.5 0-166.7-47.6-204.8-114.3L569.2 262c-19.1-28.6-47.6-47.6-81-47.6-14.3 0-23.8 4.8-38.1 4.8L202.4 323.9v223.9h95.3v-162l85.7-33.3L250 1024h100l85.7-381 100 95.3V1024H631V666.8l-100-95.3 28.6-142.9c61.9 71.5 157.2 119.1 262 119.1z"
  }));
}

var ForwardRef = React.forwardRef(SvgWalkingMan);
var _default = ForwardRef;
exports.default = _default;